
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSidebar } from "../../SidebarContext";
import Header from "../Header";
import Sidebar from "../SideBar";
import AddDeveloperCategoryModal from "./AddDevelopercategoryModal";
import EditDeveloperModal from "./EditDeveloperCategory";
import { toast } from "react-toastify";


function AddDeveloperCategory() {
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    let [allcategory, SetCategory] = useState({
        category: "",
        status: "",
        position: "",
        user_id: isLoggedIn.user_id
    });
    const [customers, setCustomers] = useState([]);

    const [showAlert, setShowAlert] = useState(false);
    const { isSidebarOpen } = useSidebar();
    const [filteredCustomers, setFilteredCustomers] = useState(customers);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const filtered = customers.filter((customer) =>
            Object.values(customer).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredCustomers(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, customers]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
    const currentData = filteredCustomers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleChange = (e) => {
        const { name, value } = e.target;
        SetCategory(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`https://100real.xyz/categoryfeaturedev/addcategory`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(allcategory)
            });
            const res = await response.json();

            setShowAlert(true); // Show alert on success
            SetCategory({
                category: "",
                status: "",
                position: "",
                user_id: isLoggedIn.user_id
            })
            fetchData();
            // Hide alert after 3 seconds (optional)
            setTimeout(() => {
                setShowAlert(false);
            }, 3000);
        } catch (error) {
            toast.error("Error adding category", {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });
        }
    };

    const edit = (
        <i className="fa-solid fa-pen"></i>
    );

    const remove = (
        <i className="fa-solid fa-trash"></i>
    );

    const [show6, setShow6] = useState(false);
    const handleClose6 = () => setShow6(false);
    const handleShow6 = () => setShow6(true);
    const [show7, setShow7] = useState(false);
    const handleClose7 = () => setShow7(false);
    const handleShow7 = () => setShow7(true);
    const [data, setData] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [imagePreview, setImagePreview] = useState('')
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        category: '',
        status: '',
        position: '',
        user_id: isLoggedIn.user_id
    });

    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit1 = async (e) => {
        e.preventDefault();
        try {
            const url = `https://100real.xyz/categoryfeaturedev/change-category/${editId}`;
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                fetchData(); // Refresh the data after successful submission
                handleClose7();
                setEditId(null);
                setFormData({ category: '', status: '', position: '', user_id: isLoggedIn.user_id });
            } else {
                console.error('Failed to submit form');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const fetchData = async () => {
        try {
            const response = await fetch(`https://100real.xyz/categoryfeaturedev/getcategory/${isLoggedIn.user_id}`);
            const res = await response.json();
            setCustomers(res);

        } catch (error) {
            toast.error("Error fetching data", {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });
        }
    };


    const handleDetete = async (id) => {
        try {
            let response = await fetch(`https://100real.xyz/categoryfeaturedev/delete-category/${id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json"
                }
            })
            let res = await response.json();
            setCustomers(customers.filter((movie) => movie.id !== id));
        } catch (error) {

        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Developers</h1>

                    {/* Add Offers Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add Developer
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Customer Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                            <th>Add Property</th>
                                <th>Image</th>
                                <th>Developer Name</th>
                                <th>Status</th>
                                <th>Position</th>
                                <th>Action</th>

                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((customer, index) => (
                                    <tr key={index}>
                                        <td
                                            style={{
                                                cursor: "pointer",
                                                maxWidth: "100px",
                                            }}
                                            onClick={() => navigate(`/adddeveloper/${customer.id}`)}
                                        >
                                            Add
                                        </td>
                                        <td>
                                            <img src={`https://100real.xyz/${customer.image_logo}`} alt="" style={{ width: '40px', height: "40px", borderRadius: '50%' }} />
                                        </td>
                                        <td style={{ cursor: "pointer" }} >{customer.category}</td>
                                        {/* <td>
                                            <a href={`/${customer.receipt}`} target="_blank" rel="noopener noreferrer">
                                                View
                                            </a>
                                        </td> */}
                                        <td>{customer.status}</td>
                                        <td>{customer.position}</td>

                                        <td>
                                            <button className="edit-button" onClick={() => {

                                                setEditId(customer.id);
                                                setFormData({
                                                    category: customer.category,
                                                    status: customer.status,
                                                    position: customer.position,
                                                    user_id: isLoggedIn.user_id
                                                })
                                                setImagePreview(customer.image_logo)
                                                setIsModalOpen1(true)
                                            }}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button
                                                className="delete-button"
                                                onClick={() => handleDetete(customer.id)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center' }}>No data found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>

                

                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>

            <AddDeveloperCategoryModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} fetchData={fetchData} />
            <EditDeveloperModal isOpen={isModalOpen1} setIsOpen={setIsModalOpen1} fetchData={fetchData} editId={editId} formData={formData} setFormData={setFormData} imagePreview={imagePreview} />
        </>
    )
}

export default AddDeveloperCategory;